import { useNavigate } from 'react-router-dom';
import { Linkedin, Twitter, Mail, Phone } from 'lucide-react';

export const LandingFooter = () => {
  const navigate = useNavigate();

  return (
    <footer className="py-12 px-4 relative">
      <div className="max-w-7xl mx-auto glass-card rounded-[50px] p-10 md:p-16 relative overflow-hidden">
        
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16 relative z-10">
          {/* Logo & Description */}
          <div className="md:col-span-3 flex flex-col justify-between">
            <div>
              <div className="flex items-center gap-3 mb-6 cursor-pointer" onClick={() => navigate('/')}>
                <img 
                  src="/ReflowAI Logo.png" 
                  alt="ReflowAI" 
                  className="w-10 h-10 rounded-lg object-contain"
                  width="50"
                  height="50"
                  loading="lazy"
                />
                <span className="text-2xl font-bold tracking-tight text-[#0F172A]">Reflow AI</span>
              </div>
              <p className="text-[#555663] text-base leading-relaxed mb-8">
                Market Intelligence for modern Quick Commerce. Delivering clarity in a distracted market.
              </p>
            </div>
            
            <div className="flex gap-4">
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-[#C6D1D7] flex items-center justify-center text-[#555663] hover:bg-[#2F7EDA] hover:text-white hover:border-[#2F7EDA] transition-all cursor-pointer">
                  <Linkedin className="w-4 h-4" />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-[#C6D1D7] flex items-center justify-center text-[#555663] hover:bg-[#2F7EDA] hover:text-white hover:border-[#2F7EDA] transition-all cursor-pointer">
                  <Twitter className="w-4 h-4" />
                </a>
            </div>
          </div>
          
          {/* What We Solve */}
          <div className="md:col-span-3">
            <h4 className="font-bold text-[#0F172A] mb-6">What We Solve</h4>
            <ul className="space-y-3">
              <li>
                <a href="/visibility" className="text-sm text-[#555663] hover:text-[#2F7EDA] font-medium transition-colors hover:translate-x-1 inline-block duration-200">Improve Visibility</a>
              </li>
              <li>
                <a href="/availability" className="text-sm text-[#555663] hover:text-[#2F7EDA] font-medium transition-colors hover:translate-x-1 inline-block duration-200">Protect Availability</a>
              </li>
              <li>
                <a href="/pricing" className="text-sm text-[#555663] hover:text-[#2F7EDA] font-medium transition-colors hover:translate-x-1 inline-block duration-200">Fix Pricing Gaps</a>
              </li>
              <li>
                <a href="/competitor" className="text-sm text-[#555663] hover:text-[#2F7EDA] font-medium transition-colors hover:translate-x-1 inline-block duration-200">Track Competitor Moves</a>
              </li>
              <li>
                <a href="/performance" className="text-sm text-[#555663] hover:text-[#2F7EDA] font-medium transition-colors hover:translate-x-1 inline-block duration-200">Measure Performance</a>
              </li>
            </ul>
          </div>

          {/* Company - Hidden on mobile */}
          <div className="hidden md:block md:col-span-2">
            <h4 className="font-bold text-[#0F172A] mb-6">Company</h4>
            <ul className="space-y-3">
              <li>
                <span className="text-sm text-[#555663] font-medium cursor-not-allowed opacity-60">Our Story</span>
              </li>
              <li>
                <span className="text-sm text-[#555663] font-medium cursor-not-allowed opacity-60">Blogs</span>
              </li>
            </ul>
          </div>

          {/* Content - Hidden on mobile */}
          <div className="hidden md:block md:col-span-2">
            <h4 className="font-bold text-[#0F172A] mb-6">Content</h4>
            <ul className="space-y-3">
              <li>
                <span className="text-sm text-[#555663] font-medium italic">"Coming Soon"</span>
              </li>
            </ul>
          </div>

          {/* Contact Us */}
          <div className="md:col-span-2">
            <h4 className="font-bold text-[#0F172A] mb-6">Contact Us</h4>
            <ul className="space-y-3">
              <li>
                <a href="tel:+919013170844" className="text-sm text-[#555663] hover:text-[#2F7EDA] font-medium transition-colors flex items-start gap-2 group">
                  <Phone className="w-4 h-4 mt-0.5 flex-shrink-0" />
                  <div>
                    <div>+91 90131 70844</div>
                    <div className="text-xs text-[#9FA0B5]">(Amol Jain)</div>
                  </div>
                </a>
              </li>
              <li>
                <a href="tel:+919748801477" className="text-sm text-[#555663] hover:text-[#2F7EDA] font-medium transition-colors flex items-start gap-2 group">
                  <Phone className="w-4 h-4 mt-0.5 flex-shrink-0" />
                  <div>
                    <div>+91 77488 01477</div>
                    <div className="text-xs text-[#9FA0B5]">(Priyanshu Sharma)</div>
                  </div>
                </a>
              </li>
              <li>
                <a href="mailto:connect@reflowai.in" className="text-sm text-[#555663] hover:text-[#2F7EDA] font-medium transition-colors flex items-center gap-2 group">
                  <Mail className="w-4 h-4 flex-shrink-0" />
                  connect@reflowai.in
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-[#C6D1D7]/50 flex flex-col md:flex-row justify-between items-center gap-4 relative z-10">
          <div className="text-[#6B7280] text-sm font-medium">
            © 2026 ReflowAI Intelligence Inc.
          </div>
          <div className="flex gap-8 text-sm text-[#6B7280] font-medium">
             <a href="#" className="hover:text-[#2F7EDA] transition-colors">Privacy Policy</a>
             <a href="#" className="hover:text-[#2F7EDA] transition-colors">Terms of Service</a>
          </div>
        </div>

        <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-gradient-to-b from-[#2F7EDA]/5 to-transparent rounded-full blur-3xl pointer-events-none -translate-y-1/2 translate-x-1/3"></div>
        <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-gradient-to-t from-[#9FA0B5]/10 to-transparent rounded-full blur-3xl pointer-events-none translate-y-1/3 -translate-x-1/3"></div>

      </div>

      {/* Global Styles for Glass Effect */}
      <style>{`
        .glass-card {
          background: linear-gradient(145deg, rgba(255,255,255,0.7) 0%, rgba(237,239,243,0.5) 100%);
          backdrop-filter: blur(24px);
          -webkit-backdrop-filter: blur(24px);
          border: 1px solid #C6D1D7;
          transition: all 0.4s cubic-bezier(0.25, 1, 0.5, 1);
        }
      `}</style>
    </footer>
  );
};
